/**
 * "Name | Name 2" for sites and suppliers, without repeating a second name
 * that equals the first (v1 `uniq(compact([name, name2]))`).
 */
export const formatNameWithSecondary = (
  name: string | null | undefined,
  name2: string | null | undefined,
): string => {
  const names = [name, name2].filter(
    (value): value is string => typeof value === 'string' && value.length > 0,
  )
  return [...new Set(names)].join(' | ')
}
